// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rowContainer__NPC5z {
  display: grid;
  background-color: #ffffff;
  grid-template-columns: minmax(16%, 100px) 30% 17% 12% 10% 15%;
  grid-template-rows: 60px;
  cursor: pointer;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 0.5px solid #d7e5ea;
}

.idColumn__X6Zs2 {
  display: flex;
  padding: 0 10px 0 26px;
  justify-content: flex-start;
  box-sizing: border-box;
}

.designNameColumn__led6J {
  display: flex;
  padding: 0 10px;
  align-items: center;
  box-sizing: border-box;
}

.createdByColumn__X73zO {
  display: flex;
  padding: 0 10px;
  align-items: center;
  box-sizing: border-box;
}

.emailCreatedBy__UQ0yh {
  display: flex;
  flex-grow: 2;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}

.createdAtColumn__Pifrf {
  display: flex;
  padding: 0 10px;
  align-items: center;
  box-sizing: border-box;
}

.statusColumn__doiaO {
  display: flex;
  justify-self: center;
  justify-content: center;
  padding: 0 10px;
  box-sizing: border-box;
}

.proposal__UnupZ {
  background-color: var(--light-orange);
  border: none;
  width: 100%;
  height: 26px;
  border-radius: 15px;
  padding: 0 10px;
  box-sizing: border-box;
}

.proposal__UnupZ > p {
  color: var(--dark-orange);
}

.quoted__ntAMr {
  background-color: var(--light-lightblue);
  border: none;
  width: 100%;
  height: 26px;
  border-radius: 15px;
  padding: 0 10px;
  box-sizing: border-box;
}

.quoted__ntAMr > p {
  color: var(--dark-lightblue);
}

.lost__xAIFK {
  background-color: var(--light-red);
  border: none;
  width: 100%;
  height: 26px;
  border-radius: 15px;
  padding: 0 10px;
  box-sizing: border-box;
}

.lost__xAIFK > p {
  color: var(--dark-red);
}

.won__Zbfn8 {
  background-color: var(--light-green);
  border: none;
  width: 100%;
  height: 26px;
  border-radius: 15px;
  padding: 0 10px;
  box-sizing: border-box;
}

.won__Zbfn8 > p {
  color: var(--dark-green);
}

.buttonColumn__T07tS {
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
  padding: 0 10px;
  justify-content: center;
  box-sizing: border-box;
}

.emailLink__fI92r {
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: var(--dark-grey);
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/components/design-list-row/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,6DAA6D;EAC7D,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":[".rowContainer {\n  display: grid;\n  background-color: #ffffff;\n  grid-template-columns: minmax(16%, 100px) 30% 17% 12% 10% 15%;\n  grid-template-rows: 60px;\n  cursor: pointer;\n  align-items: center;\n  box-sizing: border-box;\n  border-bottom: 0.5px solid #d7e5ea;\n}\n\n.idColumn {\n  display: flex;\n  padding: 0 10px 0 26px;\n  justify-content: flex-start;\n  box-sizing: border-box;\n}\n\n.designNameColumn {\n  display: flex;\n  padding: 0 10px;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.createdByColumn {\n  display: flex;\n  padding: 0 10px;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.emailCreatedBy {\n  display: flex;\n  flex-grow: 2;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n}\n\n.createdAtColumn {\n  display: flex;\n  padding: 0 10px;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.statusColumn {\n  display: flex;\n  justify-self: center;\n  justify-content: center;\n  padding: 0 10px;\n  box-sizing: border-box;\n}\n\n.proposal {\n  background-color: var(--light-orange);\n  border: none;\n  width: 100%;\n  height: 26px;\n  border-radius: 15px;\n  padding: 0 10px;\n  box-sizing: border-box;\n}\n\n.proposal > p {\n  color: var(--dark-orange);\n}\n\n.quoted {\n  background-color: var(--light-lightblue);\n  border: none;\n  width: 100%;\n  height: 26px;\n  border-radius: 15px;\n  padding: 0 10px;\n  box-sizing: border-box;\n}\n\n.quoted > p {\n  color: var(--dark-lightblue);\n}\n\n.lost {\n  background-color: var(--light-red);\n  border: none;\n  width: 100%;\n  height: 26px;\n  border-radius: 15px;\n  padding: 0 10px;\n  box-sizing: border-box;\n}\n\n.lost > p {\n  color: var(--dark-red);\n}\n\n.won {\n  background-color: var(--light-green);\n  border: none;\n  width: 100%;\n  height: 26px;\n  border-radius: 15px;\n  padding: 0 10px;\n  box-sizing: border-box;\n}\n\n.won > p {\n  color: var(--dark-green);\n}\n\n.buttonColumn {\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: flex-end;\n  padding: 0 10px;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.emailLink {\n  font-family: 'Helvetica Neue', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--dark-grey);\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rowContainer": `rowContainer__NPC5z`,
	"idColumn": `idColumn__X6Zs2`,
	"designNameColumn": `designNameColumn__led6J`,
	"createdByColumn": `createdByColumn__X73zO`,
	"emailCreatedBy": `emailCreatedBy__UQ0yh`,
	"createdAtColumn": `createdAtColumn__Pifrf`,
	"statusColumn": `statusColumn__doiaO`,
	"proposal": `proposal__UnupZ`,
	"quoted": `quoted__ntAMr`,
	"lost": `lost__xAIFK`,
	"won": `won__Zbfn8`,
	"buttonColumn": `buttonColumn__T07tS`,
	"emailLink": `emailLink__fI92r`
};
export default ___CSS_LOADER_EXPORT___;
